/* ==========================================================================
   Checkbox > Protoype
   ========================================================================== */
const inputPrototype = require('../../../input/client/js/prototype');

const checkbox = {
    ...inputPrototype,
    /* Status is checked */
    isChecked: function Fn() {
        return this.getInput().checked;
    },

    /* Check */
    check: function Fn() {
        if (!this.isChecked()) this.getInput().checked = true;

        return this;
    },

    /* Uncheck */
    uncheck: function Fn() {
        if (this.isChecked()) this.getInput().checked = false;

        return this;
    },

    /* On change */
    onChange: function Fn(event = false) {
        /* Get track of the new value in the instance based on the input one */
        if (this.value !== this.getInput().value) this.set(this.getInput().value, false);

        /* Fire external callbacks */
        if (this.config.onChange.length > 0) this.config.onChange.forEach(item => item.call(this, this, event));

        return this;
    },

    /* Add event listener */
    addEventListener: function Fn() {
        /* Bind events */
        this.bindEvents();

        /* On change */
        this.getInput().addEventListener('change', this.onChange);

        return this;
    },

    /* Remove event listener */
    removeEventListener: function Fn() {
        /* On change */
        this.getInput().removeEventListener('change', this.onChange);

        return this;
    },

    /* Bind events */
    bindEvents: function Fn() {
        this.onChange = this.onChange.bind(this);

        return this;
    },

    /* Init */
    init: function Fn() {
        /* Connect the label in case it has it with its input */
        this.setPairing();

        /* Adding listener */
        this.addEventListener();
    }
};

module.exports = checkbox;
